module.exports = __webpack_public_path__ + "img/close.9389cc23.svg";